<template>
    <div
        class="slice slice-spacer"
        :class="{'slice-spacer--hide-in-mobile': slice.primary.hideInMobile}"
        :style="spacerStyle"
        aria-hidden="true"
    ></div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {SpacerSliceSlice} from '@prismicio-types';

    const {slice} = defineProps(getSliceComponentProps<SpacerSliceSlice>());

    const spacerStyle = computed(() => ({
        '--spacer-height': `${slice.primary.spacerHeight ?? 0}px`,
        '--spacer-height-mobile': `${slice.primary.mobileSpacerHeight ?? 0}px`,
    }));
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-spacer {
        height: var(--spacer-height-mobile);

        @include mq.screen_sm(min) {
            height: var(--spacer-height);
        }

        &--hide-in-mobile {
            display: none;

            @include mq.screen_sm(min) {
                display: block;
            }
        }
    }
</style>
